const ResultDemonstrative = () => import(/* webpackChunkName: "resultDemonstrative" */ './ResultDemonstrative.vue')
const ConfigResultDemonstrative = () => import(/* webpackChunkName: "configResultDemonstrative" */ './ConfigResultDemonstrative.vue')

const index = {
  path: 'demonstrative/result',
  name: 'Result Demonstrative',
  component: ResultDemonstrative,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const config = {
  path: 'demonstrative/result/config',
  name: 'Config Result Demonstrative',
  component: ConfigResultDemonstrative,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index,
  config
}
